const stateTypes = {
  currentUnit: 'currentUnit',
  units: 'units',
  currentMachine: 'currentMachine',
  currentWires: 'currentWire',
  wiresOptionForPosition: 'wiresOptionForPosition',
  machinesConfigurations: 'machinesConfigurations',
  copyConfiguration: 'copyConfiguration',
  easySetup: 'easySetupData'
};

const getterTypes = {
  UnitApi: 'UnitAPiGetter',
  getAllUnits: 'getAllUnitsGetter',
  getCurrentUnit: 'getCurrentUnitGetter',
  getCurrentWires: 'getCurrentWireGetter',
  getWiresOptionForPosition: 'wiresOptionForPositionGetter',
  getMachinesConfigurations: 'getMachinesConfigurationsGetter',
  getCurrentMachine: 'getCurrentMachineGetter',
  getCopyConfiguration: 'getCopyConfigurationGetter',
  getEasySetupData: 'getEasySetupDataGetter'
};

const mutationTypes = {
  addUnits: 'addUnitsMutations',
  addCurrentUnit: 'addEditedUnitMutations',
  addCardToCurrentUnit: 'addCardToCurrentUnitMutations',
  addGroupToCurrentUnit: 'addGroupToCurrentUnitMutations',
  deleteGroup: 'deleteGroupMutations',
  deleteCard: 'deleteCardMutations',
  moveMachineCard: 'moveMachineCardMutations',
  setCurrentMachine: 'setCurrentMachineMutations',
  setCurrentWires: 'setCurrentWireMutations',
  setWiresOptionForPosition: 'setWiresOptionForPositionMutations',
  setMachinesConfigurations: 'setMachinesConfigurationsMutations',
  setMaintenance: 'setMaintenanceMutation',
  setCopyConfiguration: 'setCopyConfigurationMutation',
  setEasySetup: 'setEasySetup'
};

const actionTypes = {
  saveUnit: 'saveUnitAction',
  createUnit: 'createUnitAction',
  getAllUnits: 'getAllUnitsAction',
  uploadImage: 'uploadImageAction',
  setContacts: 'setContactsAction',
  updateUnit: 'updateUnitAction',
  shareUnit: 'shareUnitAction',
  changePermission: 'changePermissionAction',
  leaveUnit: 'leaveUnitAction',
  removeUser: 'removeUserAction',
  manageRights: 'manageRightsAction',
  deleteUnit: 'deleteUnitAction',
  saveGroups: 'saveGroupsAction',
  getOneUnit: 'getOneUnitAction',
  editUnit: 'editUnitAction',
  moveMachine: 'moveMachineAction',
  addCard: 'addCardAction',
  deleteCard: 'deleteCardAction',
  updateCard: 'updateCardAction',
  updateCardName: 'updateCardNameAction',
  addGroup: 'addGroupAction',
  deleteGroup: 'deleteGroupAction',
  renameGroup: 'renameGroupAction',
  renameCard: 'renameCardAction',
  getCurrentMachine: 'getCurrentMachineAction',
  copyProductionCounter: 'copyProductionCounterAction',
  getCurrentWires: 'getCurrentWireAction',
  getWiresOptionForPosition: 'getWiresOptionForPositionAction',
  setWireOnPosition: 'setWireOnPositionAction',
  removeWireOnPosition: 'removeWireOnPositionAction',
  updateTons: 'updateTonsAction',
  getMachinesConfigurations: 'getMachinesConfigurationsAction',
  getMatchingMachinesConfigurations: 'getMatchingMachinesConfigurationsAction',
  identifyMachine: 'identifyMachineAction',
  maintenance: 'maintenanceAction',
  getCopyConfiguration: 'getCopyConfigurationAction',
  copyConfiguration: 'copyConfigurationAction',
  getEasySetupData: 'getEasySetupDataAction',
  changeMachineStateAction: 'changeMachineStateAction'
};

export { stateTypes, getterTypes, mutationTypes, actionTypes };
